<template>
	<v-sheet elevation="0">
		<v-dialog
			v-model="templateDialog"
			max-width="700px"
			no-click-animation
			persistent
			:fullscreen="$vuetify.breakpoint.xs ? true : false"
			:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
		>
			<v-card :tile="$vuetify.breakpoint.xs">
				<v-app-bar dense dark flat color="primary">
					<v-app-bar-title class="color-white">テンプレートを選択する</v-app-bar-title>
					<v-spacer />
				</v-app-bar>
				<v-form class="pa-2" ref="templateForm" v-model="templateValid">
					<v-select
						v-model="selectedTemplate"
						label="テンプレートを選択する"
						:items="templates"
						item-text="name"
						item-value="id"
						:rules="[rules.required]"
						hint="テンプレートを選択してください"
						no-data-text="テンプレートデータを取得できませんでした。"
						class="mt-4"
						outlined
						dense
					/>
				</v-form>
				<v-card-actions>
					<v-row no-gutters class="pb-2" justify="center">
						<v-btn color="secondary" @click="chooseTemplate" :disabled="!templateValid">
							<v-icon class="mr-2">mdi-checkbox-outline</v-icon>
							決定する
						</v-btn>
					</v-row>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<FunctionTitle :title="'日報作成'" />
		<CommonFlame :title="template.name">
			<v-sheet class="pa-2" elevation="0">
				<v-form ref="form" v-model="valid">
					<DailyReportForm
						:template="template"
						:dailyReport.sync="daily_report"
					/>
					<v-row no-gutters justify="center">
						<v-btn @click="submitForm" :disabled="!valid" color="primary">作成する</v-btn>
					</v-row>
				</v-form>
			</v-sheet>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import axios from "axios"
import moment from "moment/min/moment.min.js"

import rules from "../../helper/rules"
import errorHandling from "../../helper/errorHandling"
import authenticate from "../../helper/authenticate"
import DailyReportForm from "./components/DailyReportForm.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"

export default {
	components: {
		DailyReportForm,
		FunctionTitle,
		CommonFlame,
	},
	data() {
		return {
			template_id: this.$route.params.template_id,
			template: {
				name: "",
				meta_keys: [],
			},
			department: {
				id: null,
				name: null,
			},
			daily_report: {
				title: null,
				place: null,
				memo: null,
				report_date: moment().format("yyyy-MM-DD"),
				start_at: null,
				end_at: null,
				matter_id: null,
				files: [],
				daily_report_meta_values_attributes: [],
			},
			valid: false,
			rules: rules,
			selectedTemplate: null,
			templateValid: false,
			templates: [],
		}
	},
	mounted() {
		authenticate.authenticateUser()
		if (this.template_id) {
			this.fetchTemplate(this.template_id)
		} else {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/daily_reports/new`
			axios
				.get(url, { headers })
				.then((res) => {
					this.templates = res.data.templates
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		}
	},
	methods: {
		chooseTemplate() {
			this.fetchTemplate(this.selectedTemplate)
		},
		fetchTemplate(template_id) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/daily_report_templates/${template_id}/daily_reports/new`
			axios
				.get(url, { headers })
				.then((res) => {
					this.template = res.data.template
					this.department = res.data.department
					this.template.meta_keys.forEach((m) => {
						let meta_value = { daily_report_meta_key_id: m.id }
						if (m.meta_type == "association") {
							meta_value.target_id = null
							meta_value.target_type = null
						} else {
							meta_value[`value_${m.meta_type}`] = null
						}
						this.daily_report.daily_report_meta_values_attributes.push(meta_value)
					})
					this.template_id = template_id
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		submitForm() {
			if (!this.$refs.form.validate()) return
			let daily_report = Object.assign({}, this.daily_report)
			delete daily_report.files
			const headers = authenticate.setHeader()
			const url = `/erp/v1/daily_report_templates/${this.template_id}/daily_reports`
			axios
				.post(url, { daily_report }, { headers })
				.then((response) => {
					const id = response.data
					if (!this.daily_report.files.length) return this.successUpload()
					this.uploadFiles(id, 0)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		uploadFiles(id, i) {
			let headers = authenticate.setHeader()
			headers["Content-type"] = "multipart/form-data"
			let formData = new FormData()
			formData.append("daily_report[file]", this.daily_report.files[i])
			axios
				.post(`/erp/v1/daily_reports/${id}/daily_report_files`, formData, { headers })
				.then((res) => {
					this.daily_report.files[i]
					if (this.daily_report.files.length == i + 1) return this.successUpload()
					this.uploadFiles(id, i + 1)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
					this.$router.push({
						name: "daily_report_edit",
						params: { template_id: this.template_id, id },
					})
				})
		},
		successUpload() {
			this.$router.push({
				name: "daily_report_index",
				params: { department_id: this.department.id },
			})
			this.$store.dispatch("setFlash", {
				type: "notice",
				text: "日報を作成しました。",
			})
		},
	},
	computed: {
		templateDialog() {
			return this.template_id ? false : true
		},
	},
}
</script>